import { createApp, reactive, h } from "vue";
import Toast from "@/components/shared/Toast.vue";

const state = reactive({
  visible: false,
  message: "",
  type: "error",
  onClose: null,
});

export default {
  install(app) {

    const show = (message, type = "error", onClose = null) => {
      state.message = message;
      state.type = type;
      state.onClose = typeof onClose === "function" ? onClose : null;
      state.visible = true;
    };

    const toast = {
      error: (msg, onClose) => show(msg, "error", onClose),
      warning: (msg, onClose) => show(msg, "warning", onClose),
      success: (msg, onClose) => show(msg, "success", onClose),
    };

    app.config.globalProperties.$toast = toast;

    const container = document.createElement("div");
    document.body.appendChild(container);

    createApp({
      render() {
        return h(Toast, {
          message: state.message,
          type: state.type,
          visible: state.visible,
          "onUpdate:visible": (val) => {
            state.visible = val;
            if (!val && typeof state.onClose === "function") {
              try {
                state.onClose();
              } finally {
                state.onClose = null;
              }
            }
          }
        });
      },
    }).mount(container);
  },
};